import React, {useState } from 'react'
import MyInvites from './MyInvites';
import InviteMemberForm from './InviteMemberForm';

export default function InviteUser() { // Remake of "TeamControl", Which will be implemented at scale1
  const [popInvite, setPopInvite] = useState({});

  // TODO: Remove this state?
  const [isModified, setIsModified] = useState(false);

  return (
    <div className='teamControl'>
      <div className='teamCtrlWork'>        
        <div className='teamInvites'>
          <InviteMemberForm withInvite={popInvite}/>
          <MyInvites popInviteSetter={setPopInvite} clearModified={() => setIsModified(false)}/>
        </div>
      </div>
    </div>
  )
}
